export const PRODUCT_LIST_PAGE_REQUESTED = 'PRODUCT_LIST_PAGE_REQUESTED';
export const PRODUCT_LIST_GOT_NAMESPACES = 'PRODUCT_LIST_GOT_NAMESPACES';
export const PRODUCT_LIST_GOT_PRODUCTS = 'PRODUCT_LIST_GOT_PRODUCTS';
export const SET_DEFAULT_NAMESPACE_UID = 'PRODUCT_LIST_SET_DEFAULT_NAMESPACE';
